exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".predicition-page .siteHeader{\n  margin-bottom: 0px !important;\n}\n\np.main-text {\n  font-family: CircularStd;\n  font-size: 12px;\n  font-weight: bold;\n  color: black;\n}\n\n.simulator-page-form-content{\n  width: 64% !important;\n  float: left;\n  margin-bottom: 100px;\n}\n\n.simulator-page-result-content{\n  width: 29vw;\n  background-color: #3d4e74;\n  color: white;\n  position: fixed;\n  right: 10px;\n  height: calc(100vh - 70px);\n  top: 70px;\n}\n\n.simulator-page-no-data{\n  text-align: center;\n  margin-top: 120px;\n}\n", ""]);

// exports
